import { createElementObject, createLayerComponent, extendContext } from './core';
// import { LayerGroup as LeafletLayerGroup } from '@anlan/gs-map';
import L from '@anlan/gs-map';
import type { LayerOptions } from '@anlan/gs-map';
import type { ReactNode } from 'react';
import type { EventedProps, LeafletContextInterface } from './core';
const LeafletLayerGroup = L.LayerGroup;

export interface LayerGroupProps extends LayerOptions, EventedProps {
    children?: ReactNode
}

export const LayerGroup = createLayerComponent(function createLayerGroup({ children, ...options }: LayerGroupProps, ctx: LeafletContextInterface) {
    void children;
    const group = new LeafletLayerGroup([], options);
    return createElementObject(group, extendContext(ctx, {
        layerContainer: group
    }));
});
